import type {
  IngridEventDataChangedData,
  IngridEventDataChangedMeta,
  IngridEventSummaryChangedData,
  IngridEventSummaryChangedMeta,
  IngridRecipient
} from 'ecosystem'

const INGRID_ELEMENT_ID = 'shipwallet-container'

export function replaceScriptNode(node: Node) {
  if (isScriptNode(node) && !isExternalScript(node)) {
    node.parentNode?.replaceChild(cloneScriptNode(node as Element), node)
  } else {
    let i = 0
    const children = node.childNodes

    while (i < children.length) {
      replaceScriptNode(children[i++])
    }
  }

  return node
}

function isScriptNode(node: Element | Node) {
  return (node as Element).tagName === 'SCRIPT'
}

function isExternalScript(node: Node) {
  return !!(node as HTMLScriptElement).src && (node as HTMLScriptElement).src !== ''
}

function cloneScriptNode(node: Element) {
  const script = document.createElement('script')
  script.text = node.innerHTML

  for (let i = node.attributes.length - 1; i >= 0; i--) {
    script.setAttribute(node.attributes[i].name, node.attributes[i].value)
  }
  return script
}

export const replaceIngridScriptNode = () => {
  replaceScriptNode(document.getElementById(INGRID_ELEMENT_ID) as Node)
}

export const subscribeToIngridEvents = (handlers: {
  dataChanged?: (data: IngridEventDataChangedData, meta: IngridEventDataChangedMeta) => void
  summaryChanged?: (
    data: IngridEventSummaryChangedData,
    meta: IngridEventSummaryChangedMeta
  ) => void
  loaded?: (recipient?: IngridRecipient) => void
  noShippingOptions?: () => void
}) => {
  const { dataChanged, summaryChanged, loaded, noShippingOptions } = handlers

  // @ts-expect-error -- need
  window?._sw?.((api) => {
    /**
     * Instead of exposing multiple 'change' events with multiple properties,
     * Delivery Checkout exposes one 'change' event and allows you to decide what data you care about.
     * The callback receives two arguments
     */
    if (dataChanged) {
      api.on('data_changed', dataChanged)
    }

    /**
     * Useful when utilising Address Form and Delivery Groups features.
     * If you don't have those enabled, you want to go with the Data Changed event. Exposes two arguments:
     */
    if (summaryChanged) {
      api.on('summary_changed', summaryChanged)
    }

    // Emitted when the widget is fully loaded and interactive.
    // If Address Form is used, the data will consists of Recipient object.
    if (loaded) {
      api.on('loaded', loaded)
    }

    /**
     * Emitted when the address is provided but Ingrid can't find any category options for it.
     * Note that this requires additional configuration on Ingrid side to be visible.
     * To do that, you will have to contact our support team
     */
    if (noShippingOptions) {
      api.on('no_shipping_options', noShippingOptions)
    }
  })
}
